import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-a', 'LetterA', [["path",{"d":"M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"}],["path",{"d":"M7 13l10 0"}]]);